import React from 'react';
import Icon from 'components/lib/icons/icon';

export default function ArchiveIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path
          clipRule="evenodd"
          d="M4.19153 0C3.94432 0 3.70378 0.0701777 3.50601 0.2L0.459232 2.2C0.0325917 2.48006 -0.0769123 2.9127 0.049109 3.28364C0.0176341 3.34911 1.86912e-08 3.4225 1.86912e-08 3.5V15.5C1.86912e-08 15.7761 0.223858 16 0.5 16H15.5C15.7761 16 16 15.7761 16 15.5V3.5C16 3.42249 15.9824 3.34912 15.9509 3.28364C16.0769 2.9127 15.9674 2.48006 15.5408 2.2L12.494 0.2C12.2962 0.070178 12.0557 0 11.8085 0H4.19153ZM14.8552 3L11.8085 1L4.19153 1L1.14476 3H14.8552ZM7.60582 13.8388C7.82102 14.0537 8.17897 14.0537 8.39418 13.8388L11.8461 10.3904C12.1805 10.0564 11.9342 9.5 11.4519 9.5H9.33334V6.28571C9.33334 5.57563 8.73638 5 8.00001 5C7.26363 5 6.66667 5.57563 6.66667 6.28571V9.5H4.54812C4.06583 9.5 3.81953 10.0564 4.15394 10.3904L7.60582 13.8388Z"
          fill="#9C9C9C"
          fillRule="evenodd"
        />
      </svg>
    </Icon>
  );
}
